import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import RequestState from 'Enums/RequestState'
import Styles from './OperatorUserActionsChargePoint.module.css'
import InfinityEnums from 'Enums/InfinityEnums'
import OperatorUserActionsAction from 'Stores/OperatorUserActions/Actions'
import OperatorUserActionsSelectors from 'Stores/OperatorUserActions/Selectors'
import OperatorUserActionList from 'Containers/OperatorUserActionList/OperatorUserActionList'
import {
  EmptyOperatorUserActionsCP,
  NoOperatorUserActionsCPFilter,
} from 'Components'
import AuthSelectors from 'Stores/Auth/Selectors'

const OperatorUserActionsChargePoint = ({
  chargePoint,
  fetchOperatorUserActionsChargePoint,
  operatorUserActionsChargePoint,
  operatorUserActionsFilters,
  fetchOperatorUserActionsChargePointRequestState,
  operatorUserActionsChargePointPaginationOffset,
  selectedDetails,
  setOperatorUserActionsPaginationOffset,
  canViewUptimeStats,
  operatorUser,
}) => {
  const [empty, setEmpty] = useState(true)

  useEffect(() => {
    setOperatorUserActionsPaginationOffset(0)
    if (selectedDetails === (canViewUptimeStats ? 3 : 2)) {
      fetchOperatorUserActionsChargePoint(
        chargePoint._id,
        operatorUserActionsFilters,
        operatorUserActionsChargePointPaginationOffset,
      )
    }
  }, [selectedDetails, canViewUptimeStats])

  const loadMoreData = () => {
    if (
      fetchOperatorUserActionsChargePointRequestState ===
      RequestState.LOADING_MORE
    )
      return
    fetchOperatorUserActionsChargePoint(
      chargePoint._id,
      operatorUserActionsFilters,
      operatorUserActionsChargePointPaginationOffset,
    )
  }
  const handleRetryOperatorUserActions = () => {
    fetchOperatorUserActionsChargePoint(
      chargePoint._id,
      operatorUserActionsFilters,
      operatorUserActionsChargePointPaginationOffset,
    )
  }
  const checkFilterEmpty = (newFilter) => {
    const emptyFlag = !newFilter.some((filter) => filter.value.length !== 0)
    if (emptyFlag) setEmpty(true)
    else setEmpty(false)
  }
  useEffect(() => {
    checkFilterEmpty(operatorUserActionsFilters)
  }, [operatorUserActionsFilters])

  return (
    <div className={Styles.container}>
      {operatorUserActionsChargePoint.length === 0 &&
      fetchOperatorUserActionsChargePointRequestState !==
        RequestState.LOADING ? (
        empty ? (
          <EmptyOperatorUserActionsCP />
        ) : (
          <NoOperatorUserActionsCPFilter />
        )
      ) : (
        <OperatorUserActionList
          operatorUserActions={operatorUserActionsChargePoint}
          paginationOffset={operatorUserActionsChargePointPaginationOffset}
          fetchOperatorUserActionsRequestState={
            fetchOperatorUserActionsChargePointRequestState
          }
          operatorUserActionsType={InfinityEnums.Models.ChargePoint}
          loadMoreData={() => loadMoreData()}
          handleRetry={() => handleRetryOperatorUserActions()}
          operatorUser={operatorUser}
        />
      )}
    </div>
  )
}

function mapDispatchToProps(dispatch) {
  return {
    fetchOperatorUserActionsChargePoint: (chargePointId, filter, offset) =>
      dispatch(
        OperatorUserActionsAction.fetchOperatorUserActionsChargePoint(
          chargePointId,
          filter,
          offset,
        ),
      ),
    resetOperatorUserActionsChargePoint: () =>
      dispatch(OperatorUserActionsAction.resetOperatorUserActionsChargePoint()),
    setOperatorUserActionsPaginationOffset: (offset) =>
      dispatch(
        OperatorUserActionsAction.setOperatorUserActionsPaginationOffset(
          offset,
        ),
      ),
  }
}

const mapStateToProps = (state) => ({
  operatorUserActionsChargePoint:
    OperatorUserActionsSelectors.getOperatorUserActionsChargePoint(state),
  operatorUserActionsFilters:
    OperatorUserActionsSelectors.getOperatorUserActionsFilters(state),
  fetchOperatorUserActionsChargePointRequestState:
    OperatorUserActionsSelectors.getFetchOperatorUserActionsChargePointRequestState(
      state,
    ),
  operatorUserActionsChargePointPaginationOffset:
    OperatorUserActionsSelectors.getOperatorUserActionsChargePointPaginationOffset(
      state,
    ),
  operatorUser: AuthSelectors.getOperatorUser(state),
})

OperatorUserActionsChargePoint.propTypes = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OperatorUserActionsChargePoint)
